(function ( $ ) {
    $.fn.checklistSelector = function(val, params) {
        $(this).each(function() {
            var elm = $(this);

            elm.attr('data-search-type', 'checklist');


            const onChange = function(obj) {
                try {
                    if(typeof obj === 'string') {
                        obj = JSON.parse(obj);
                    }
                    elm.removeClass('has-special-selector').checklistSelector(obj.id, params);
                } catch(e) {

                }
            };

            elm.specialSelector({
                val: val,
                option: function(row) {
                    return '<option value="'+row.id+'">' + row.name + '</option>';
                },
                addNew: function() {
                    const popup = $('.reveal-overlay:visible:last');
                    const form = $('<form />');

                    popup.find('input[data-checklist-append-to]').clone().appendTo(form);
                    const data = form.serializeJSON();

                    add_checklist(function(checklist) {
                        onChange(checklist);
                    }.bind([elm]), data);
                }.bind([elm]),
                onOpen: function(id) {
                    view_checklist(id, {
                        callback: function(obj, elm, popup) {
                            onChange(obj);
                            popup.close();
                        }
                    });
                }
            });
        });
        return this;
    };

}( jQuery ));